import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import { ItemListStyles } from './ItemList.styled';
import Link from 'next/link';

const LIST_WIDTH = 235; // px width for item list

const ItemList = ({
  items,
  navId,
  selectedItem = undefined,
  onSelect = null,
}) => {
  const [xOffset, setXOffset] = useState(0);

  useLayoutEffect(() => {
    if (typeof document !== 'undefined') {
      const boundingListElm = document.getElementById(`list-navitem-${navId}`);

      // The element can be null if no list items.
      if (boundingListElm) {
        const boundingList = boundingListElm.getBoundingClientRect();
        if (boundingList.x < 0) {
          const xoffset = 20 - boundingList.x;
          setXOffset(xoffset);
        } else if (boundingList.x + LIST_WIDTH > window.innerWidth) {
          const xoffset =
            window.innerWidth - (boundingList.x + LIST_WIDTH) - 20;
          setXOffset(xoffset);
        } else {
          setXOffset(0);
        }
      } else {
        setXOffset(0);
      }
    }
  }, [navId]);

  const itemNodes =
    items.length > 0
      ? items.map((temp, i) => {
          return (
            <li
              className={'item-info'}
              key={`${temp.text}-${i}`}
              onClick={() => {
                if (onSelect) {
                  onSelect();
                }
              }}
            >
              {temp.external ? (
                <a
                  id={`navitem-${navId}-${i}`}
                  href={temp.slug}
                  className={selectedItem === temp.text ? 'selected' : ''}
                >
                  <p>{temp.text}</p>
                </a>
              ) : (
                <Link
                  href={temp.slug}
                  id={`navitem-${navId}-${i}`}
                  className={selectedItem === temp.text ? 'selected' : ''}
                >
                  <p>{temp.text}</p>
                </Link>
              )}
            </li>
          );
        })
      : null;

  const result =
    itemNodes && itemNodes.length > 0 ? (
      <div className="item-list-wrap">
        <div className="item-list">
          <ul id={`list-navitem-${navId}`}>{itemNodes}</ul>
        </div>
      </div>
    ) : null;

  return (
    <ItemListStyles
      className="item-list-container"
      xOffset={xOffset}
      listWidth={LIST_WIDTH}
    >
      {result}
    </ItemListStyles>
  );
};

ItemList.propTypes = {
  items: PropTypes.array.isRequired,
  navId: PropTypes.any.isRequired,
  onSelect: PropTypes.func,
  selectedItem: PropTypes.any,
};

export default ItemList;
